// -*-mode: rjsx -*-

/*
Curently there is a split between Preview.js (preview) and Summary.js (Track and Share)
...but they probably should b e1 single screen. We have that in B/Summary-singlescree.js

It can be merged quickly just to 1 single screen in Summary, the code is simply
commented out and NEXT can be just switched to submit
*/

// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
// eslint-disable-next-line
import Favorite from "@material-ui/icons/Favorite"
// eslint-disable-next-line
import FavoriteBorder from "@material-ui/icons/FavoriteBorder"
// eslint-disable-next-line
import UncheckedCircle from "@material-ui/icons/RadioButtonUnchecked"
// eslint-disable-next-line
import CheckedCircle from "@material-ui/icons/CheckCircleOutline"
// eslint-disable-next-line
import Card from "@material-ui/core/Card"
// eslint-disable-next-line
import Checkbox from "@material-ui/core/Checkbox"
import ShareIcon from '@material-ui/icons/Share';
import Fab from "@material-ui/core/Fab"
import DownIcon from "@material-ui/icons/KeyboardArrowDown"
import UpIcon from "@material-ui/icons/KeyboardArrowUp"
// eslint-disable-next-line
import HelpIcon from "@material-ui/icons/HelpOutline"
import grey from "@material-ui/core/colors/grey"
import Paper from "@material-ui/core/Paper"

// UTILS
import * as _ from "lodash"
// import * as moment from "moment"

// FLASH
// eslint-disable-next-line
import FlashTopBar from "../Flash/FlashTopBar.js"
import FlashHeader from "../Flash/FlashHeader.js"
// eslint-disable-next-line
import FlashSubHeader from "../Flash/FlashSubHeader.js"
// import FlashBottomBar from "../Flash/FlashBottomBar.js"
import FlashShare from "./../FlashShare.js"
import FlashIssueChart from "../Flash/FlashIssueChart.js"
import FlashReasonsChart from "../Flash/FlashReasonsChart.js"
import FlashBottomPad from "../Flash/FlashBottomPad.js"
// import LogRocket from 'logrocket'

import {
    deepCopy,
} from "../Utils"

import { 
    genUrl
} from "../../bl/A/bl"


// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<Summary>")
//LogRocket.init('sbqpcc/flashdev')




const styles = theme => ({
    //
    // GLOBAL STYLES START
    //
    
    separatorDiv: {
        ...theme.css.separatorDiv,
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            width: theme.css.separatorDiv.desktop.width,
            height: theme.css.separatorDiv.desktop.height,
            marginTop: theme.css.separatorDiv.desktop.marginTop, // separate sections
            marginLeft: theme.css.separatorDiv.desktop.marginLeft,
            // borderRadius: theme.css.separatorDiv.desktop.borderRadius,
            // boxShadow: theme.css.separatorDiv.desktop.boxShadow,
            // borderTopLeftRadius: 6,
            // borderTopRightRadius: 6,
        },
    },

    checkedCircle: {
        ...theme.css.checkedCircle
    },

    uncheckedCircle: {
        ...theme.css.uncheckedCircle
    },


    //
    // GLOBAL STYLES END
    //

/*
    // SCROLL FAB
    fab: {
        position: "fixed",
        bottom: theme.spacing(12),
        //        right: theme.spacing(1),
        left: "65%",
        zIndex: 10,
        
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            left: "60%",
        },

    },
    
    fabGreen: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.custom.scrollDark,
        '&:hover': {
            backgroundColor: theme.palette.custom.scrollLight,
        },
    },
  */  
    
    continueButton: {
        margin: 20,
        padding: 8,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },


    contactList: {
        margin: 0,
        marginTop: 0,
        // tab from the left
        padding: "0px",
        // inside the container
        width: "100%",
    },

    contactItem: {
        // gap between cards (individual items)
        margin: 0,
        // cursor: "pointer",
        borderRadius: 0, // default 4
    },


    //
    // new stuff
    //
    mainDiv: {
        // mobile
        marginTop: 0,
        marginBottom: 0,
        marginLeft: "auto",
        marginRight: "auto",
        padding: 0,
        paddingTop: 90,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            paddingTop: 100,
	    maxWidth: 600,
//            marginBottom: 120,
        },

        color: theme.palette.test.mainFG,
        background: theme.palette.test.mainBG,
    },

    paperRoot: {
        // mobile
        margin: 0,
        maxWidth: "100%",
        padding: 10,
        paddingTop: 10,
        paddingBottom: 10,
//        maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: 15,
            borderRadius: 6,
        },
        
    },

    optionsPaperRoot: {
        // mobile
        margin: 0,
        maxWidth: "100%",
//        padding: 10,
//        paddingTop: 10,
//        paddingBottom: 10,
//        maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
//            marginTop: 15,
            //            borderRadius: 6,
            borderRadius: 0,
        },
        
    },

    // SCROLL FAB
    fab: {
        position: "fixed",
        //        bottom: theme.spacing(12),
                bottom: theme.spacing(2),

        //        right: theme.spacing(1),
        //        left: "45%", // middle

        left: "83%", // middle

        zIndex: 500,
        
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            left: "75%",
        },

    },
    
    fabGreen: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.custom.scrollDark,
        '&:hover': {
            backgroundColor: theme.palette.custom.scrollLight,
        },
    },
    
})

class Summary extends Component {
    constructor(props) {
        super(props)
        log.debug("constructor()")

        const initState =  {
            scrollerDirection: "down",
            redirectBack: false,
            redirectToStatements: false,
        }

        const drive = JSON.parse(localStorage.getItem("drive"))
        log.debug("constructor(): drive =", drive)

        if(drive && drive.name) {
            initState.drive = drive
        }

        log.debug("constructor(): initState =", initState)

        this.state = initState
        
    }

    handleContinueClick = () => {
        log.debug("handleContinueClick()")
        // get all the checked contacts
        let checkedItems = _.filter(this.state.gl.issues, ["isChecked", true])
        log.debug("handleContinueClick(): checkedItems = ", checkedItems)

        let localGL = this.state.gl
        localStorage.setItem("gl", JSON.stringify(localGL))
        log.debug("handleContinueClick(): saved localGL")

        this.setState({redirectContinue: true})
    }

    handleBackClick = () => {
        log.debug("handleBackClick()")
        this.setState({redirectBack: true})
    }

    handleCloseClick = () => {
        log.debug("handleCloseClick()")
        this.setState({redirectClose: true})
    }

    handleContactCheckboxChange = uuid => event => {
        log.debug("handleCheckboxChange(): uuid =", uuid)
        log.debug("handleCheckboxChange(): event =", event)

        log.trace(`handleCheckboxChange(): uuid = ${uuid}, event = ${event}`)
        let contact = (_.filter(this.state.gl.contacts, ["uuid", uuid]))[0]

        log.debug("handleCheckboxChange(): contact found = ", contact)
        if(!contact.isChecked) {
            contact.isChecked = true
        } else if(contact.isChecked === true) {
            contact.isChecked = false
        } else if(contact.isChecked === false) {
            contact.isChecked = false
        }

        log.trace("handleCheckboxChange(): contact.isChecked = ", contact.isChecked)
        
        this.setState({gl: this.state.gl})

        log.trace("handleCheckboxChange(): contact.isChecked = ", contact.isChecked)
        
    }

    handleCheckboxChange = slug => event => {
        const newGl = deepCopy(this.state.gl)
        
        const option = newGl.options.find(option => option.slug === slug)
        option.isChecked = !option.isChecked
        
        /*
        if(option.slug === "track-my-issue-option") {
            const isTrackingOpen = !this.state.isTrackingOpen
            this.setState({
                isTrackingOpen: true,
                //gl: newGl
            })
        }*/
        
        log.debug("handleCheckboxChange(): option =", option)
        log.debug("handleCheckboxChange(): option.isChecked =", option.isChecked)
        
        this.setState({
            isTrackingOpen: (slug === "track-my-issue-option") ? !this.state.isTrackingOpen : this.state.isTrackingOpen,
            gl: newGl
        })
    }
    
    handleCheckboxChange_old = uuid => event => {
        log.debug(` handleCheckboxChange(): uuid = ${uuid}, event = ${event}`)
        let item = (_.filter(this.state.gl.options, ["uuid", uuid]))[0]
        log.debug("handleCheckboxChange(): option found = ", item)

        
        if(!item.isChecked) {
            item.isChecked = true
        } else if(item.isChecked === true) {
            item.isChecked = false
        } else if(item.isChecked === false) {
            item.isChecked = false
        }

        log.debug("handleCheckboxChange(): item.isChecked = ", item.isChecked)

        if(item.uuid === "2") {
            if(!this.state.isTrackingOpen) {
                log.debug("handleCheckboxChange(): SET THE TRACKING")
                this.setState({
                    ...this.state,
                    isTrackingOpen: true,
                    gl: this.state.gl
                })
            } else {
                log.debug("handleCheckboxChange(): UNSET THE TRACKING")
                this.setState({
                    ...this.state,
                    isTrackingOpen: false,
                    gl: this.state.gl
                })
            }
        } else {
            this.setState({...this.state, gl: this.state.gl})
        }
    }


    handleShareClick = () => {
        log.debug("handleShareClick()")
        this.setState({isShareVisible: true})
    }

    handleShareDone = () => {
        log.debug("handleShareDone()")
        this.setState({isShareVisible: false})
    }
    
    componentWillUnmount  = () => {
        window.removeEventListener("scroll", this.handleScroll)
    }

    UNSAFE_componentWillMount = () => {
        log.debug("componentWillMount()")
        let localGL = JSON.parse(localStorage.getItem("gl"))
        log.debug("componentWillMount(): localGL = ", localGL)


//        if(!localGL.options) {
            localGL.options = [
//                {uuid: "1", txt: "Get confirmation my data was seen"},
                {slug: "track-my-issue-option", txt: "Track the impact of my issue"},
//                {uuid: "3", txt: "Be alerted on the issues, so I can alter or add to my Lighting Strike"},
//                {uuid: "4", txt: "Become a resource on the issues for my representative"},
            ]
//        }
        
        this.setState({
            gl: localGL,
            variation: {
                  current: "A",
                  A: "/summary/a",
                  B: "/summary/b",
            },
            isTrackingOpen: false,
            scrollerDirection: "down",
        })
    }


    componentDidMount = () => {
        window.addEventListener("scroll", this.handleScroll);
        if(this.headDivEl) this.scrollToTop()
    }

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    handleScroll = (event) => {
        // log.trace("<Issues>: handleScroll(): event = ", event)

        if(!this.state.scrollerDirection) {
            this.setState({scrollerDirection: "down"})
            return
        }

        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight,  html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;

        log.trace("handleScroll(): window.pageYOffset =", window.pageYOffset)

        if (windowBottom >= (docHeight - 1)) {
            this.setState({scrollerDirection: "up"})
        } else if(window.pageYOffset === 0) {
            this.setState({scrollerDirection: "down"})
        }
    }

    scrollToBottom = () => {
        log.debug("<Issues>: scrollToBottom(): this.contentDivEl = ", this.contentDivEl)
        log.debug("<Issues>: scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        this.tailDivEl.scrollIntoView({
            behavior: "smooth",
            block: "start",
        })
    }


    scrollToTop = () => {
        log.debug("<Issues>: scrollToBottom(): this.headDivEl = ", this.headDivEl)
        log.debug("<Issues>: scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        this.headDivEl.scrollIntoView({
            behavior: "smooth",
            block: "start",
        })
    }

    
    makeReasonsData = () => {


        let currentIssue = this.state.gl.currentIssue
        let statements = this.state.gl.statements
        // eslint-disable-next-line
        let currentStatements = _.filter(statements, ["issue.uuid", currentIssue.uuid])
        currentStatements = _.filter(currentStatements, ["isChecked", true])

        let data = []
        let valueMin = 20
        let valueMax = 100
        let targetMin = 0
        let targetMax = 100
        
        _.map(currentStatements, (statement) => {
            let value = Math.floor(Math.random() * (valueMax - valueMin + 1) + valueMin)
            targetMin = (value <= 1 ) ? value + 20 : value / 2
            targetMax = (value === 100) ? 90 : value + 1
            
            data.push({
                category: statement.txt,
                "value": Math.floor(Math.random() * (valueMax - valueMin + 1) + valueMin),
                "target": Math.floor(Math.random() * (targetMax - targetMin + 1) + targetMin)
            })
        })

        data = _.sortBy(data, ["value"])
        
        return data
    }

    render() {
        const { classes } = this.props

        // redirects first
        if (this.state.redirectBack) {
            return <Redirect push to="/summary"/>
        } else if(this.state.redirectClose) {
            return <Redirect push to="/summary"/>
        } else if(!this.state.gl.currentIssue) {
            // check if this is a valid location at the moment
            // we should have a valid this.state.gl.currentIssue
            return <Redirect push to="/contacts"/>
        }

        //
        // CONTACTS
        //
        let contacts = this.state.gl.contacts
        let checkedContacts = _.filter(contacts, ["isChecked", true])
        log.debug("render(): checkedContacts = ", checkedContacts)

        // City
        let cityContacts = _.filter(checkedContacts, ["level", "city"])
        let hasCityContacts = false
        if(cityContacts.length > 0) hasCityContacts = true
        log.debug("render(): hasCountyContacts = ", hasCityContacts)
        const cityItems = this.state.gl.contacts.filter(contact => {
            return contact.level === "city"
        })


        // County
        let countyContacts = _.filter(checkedContacts, ["level", "county"])
        let hasCountyContacts = false
        if(countyContacts.length > 0) hasCountyContacts = true
        log.debug("render(): hasCountyContacts = ", hasCountyContacts)
        const countyItems = this.state.gl.contacts.filter(contact => {
            return contact.level === "county"
        })

        // State
        let stateContacts = _.filter(checkedContacts, ["level", "state"])
        let hasStateContacts = false
        if(stateContacts.length > 0) hasStateContacts = true
        log.debug("render(): hasStateContacts = ", hasStateContacts)
        const stateItems = this.state.gl.contacts.filter(contact => {
            return contact.level === "state"
        })
        

        // Federal
        let federalContacts = _.filter(checkedContacts, ["level", "federal"])
        log.debug("render(): gl =", this.state.gl)
        const federalItems = this.state.gl.contacts.filter(contact => {
            return contact.level === "federal"
        })
        log.debug("render(): federalItems =", federalItems)
        

        let hasFederalContacts = false
        if(federalContacts.length > 0) hasFederalContacts = true
        log.debug("render(): hasFederalContacts = ", hasFederalContacts)


        //
        // Issues
        //
        let currentIssue = this.state.gl.currentIssue
        let statements = this.state.gl.statements
        // eslint-disable-next-line
        let currentStatements = _.filter(statements, ["issue.uuid", currentIssue.uuid])
        currentStatements = _.filter(currentStatements, ["isChecked", true])

        //
        // Options
        //
        let optionsItems = this.state.gl.options
        
        let reasonsData = this.makeReasonsData()

        console.log("reasonsData = ", reasonsData)


        log.debug("render(): currentIssue = ", currentIssue)
        

        //let nextUrl = "/contacts"
        //        if(this.state.drive) {
        //            nextUrl = "/drive/" + this.state.drive.name + "/issues"
        //        }
        //        console.log("nextUrl = ", nextUrl)

        let savedData = JSON.parse(localStorage.getItem("user"))
        log.debug("render(): savedData = ", savedData)
        // for the state list
        const user = savedData

	return(
            <React.Fragment>
	      <CssBaseline/>

              <div ref={(el) => { this.headDivEl = el }} ></div>

              <FlashShare isVisible={this.state.isShareVisible} variant="summary" onDone={this.handleShareDone}/>
              
              <FlashTopBar text="Track and Share" variation={this.state.variation}/>
              
              <div className={classes.mainDiv}>


                {/*
                <FlashHeader text="Your Representatives"/>

                { hasCityContacts &&
                  <div>
                    <div className={classes.separatorDiv}>
                      <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 18 }}>
                        City
                      </Typography>
                    </div>
                    
                    <ul className={classes.contactList}>
                      {cityContacts.map((value, index) => (
                          <Paper className={classes.paperRoot} key={index}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                              <div>
                                <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 17, fontWeight: "bold"}}>
                                  {value.personName}
                                </Typography>
                                <Typography variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16}}>
                                  {value.positionDescription}
                                </Typography>
                              </div>
                            </div>
                          </Paper>
                      ))}
                    </ul>
                  </div>
                }


                { hasCountyContacts &&
                  <div>
                    <div className={classes.separatorDiv}>
                      <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 18 }}>
                        County
                      </Typography>
                    </div>
                    
                    <ul className={classes.contactList}>
                      {countyContacts.map((value, index) => (
                          <Card className={classes.contactItem} key={index}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                              <div>
                                <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 17, fontWeight: "bold"}}>
                                  {value.personName}
                                </Typography>
                                <Typography variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16}}>
                                  {value.positionDescription}
                                </Typography>
                              </div>
                            </div>
                          </Card>
                      ))}
                    </ul>
                  </div>
                }

                { hasStateContacts &&
                  <div>
                    <div className={classes.separatorDiv}>
                      <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 18 }}>
                        State
                      </Typography>
                    </div>
                    
                    <ul className={classes.contactList}>
                      {stateContacts.map((value, index) => (
                          <Card className={classes.contactItem} key={index}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                              <div>
                            <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 17, fontWeight: "bold"}}>
                                  {value.personName}
                                </Typography>
                                <Typography variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16}}>
                                  {value.positionDescription}
                                </Typography>
                                <div/>
                              </div>
                            </div>
                          </Card>
                      ))}
                    </ul>
                  </div>
                }


                { hasFederalContacts &&
                  <div>
                    <div className={classes.separatorDiv}>
                      <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                        Federal
                      </Typography>
                    </div>
                    
                    <ul className={classes.contactList}>
                      {federalContacts.map((value, index) => (
                          <Paper className={classes.paperRoot} key={index}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                              <div>
                                <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 17, fontWeight: "bold"}}>                                  {value.personName}
                                </Typography>
                                <Typography variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16}}>
                                  {value.positionDescription}
                                </Typography>
                                <div/>
                              </div>
                            </div>
                          </Paper>
                      ))}
                    </ul>
                  </div>
                }

                 */}

                {/*
                <FlashHeader text="Your Issues"/>

                <div className={classes.separatorDiv}>
                  <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    {currentIssue.txt}
                  </Typography>
                </div>
                
                <ul className={classes.contactList}>
                  {currentStatements.map((value, index) => (
                      <Paper className={classes.paperRoot} key={index}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                          <div>
                            <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 18, fontWeight: 400 }}>
                              {value.txt}
                            </Typography>
                            <Typography variant="h6" style={{marginLeft: 20, fontSize: 17}}>
                              Rating: {value.rate}
                            </Typography>
                          </div>
                      </div>
                      </Paper>
                  ))}
                </ul>
                 */}

                <FlashHeader style = {{marginBottom: 40}} text="Choose your representative(s) to hear your response"/>
                {/* NEXT: here is the logic for showing federal and other reps */}

                {currentIssue.level === "federal" &&
                 <div>
                   <div className={classes.separatorDiv}>
                     <Typography variant="subtitle1" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                       Federal
                     </Typography>
                   </div>

                   <ul className={classes.contactList}>
                     {federalItems.map((value, index) => {
                         if(value.position.description !=="Vice President of the US")
                             return (
                                 <Paper className={clsx({
                                     [classes.paperRoot]: true,
                                     [classes.paperRoot_disabled]: value.isDisabled,
                                 })} key={index}>
                                   <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                                     <div>
                                       <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="subtitle2" style={{marginLeft: 20, fontSize: 17, fontWeight: "bold"}}>
                                         {value.position.description}
                                       </Typography>
                                       <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16}}>
                                         {value.person.name}
                                       </Typography>
                                       <div/>
                                     </div>
                                     <Checkbox
                                       icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                                       checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                                       checked={value.isChecked ? value.isChecked : false}
                                       onChange={this.handleContactCheckboxChange(value.uuid)}>
                                     </Checkbox>
                                   </div>
                                 </Paper>
                             )
                         else
                             return (<div key="nothing"/>)
                     })}
                   </ul>
                 </div>
                }



                {currentIssue.level === "state" &&
                 <div>
                   <div className={classes.separatorDiv}>
                     <Typography variant="subtitle1" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                       {/* State */}
                       {user.geo.address.state.name}
                     </Typography>
                   </div>
                   
                   <ul className={classes.contactList}>
                     {stateItems.map((value, index) => {
                         return (
                             <span key={`${index}-span`}>
                             <Paper className={clsx({
                                 [classes.paperRoot]: true,
                                 [classes.paperRoot_disabled]: value.isDisabled,
                             })} key={index}>
                               <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                                 <div>
                                   <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16, fontWeight: "bold" }}>
                                     {value.position.description}
                                   </Typography>
                                   <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="subtitle2"style={{marginLeft: 20, fontSize: 17, fontWeight: "normal"}}>
                                     {value.person.name}
                                   </Typography>
                                   <div/>
                                   {/*
                                      <Typography variant="body2" display="inline" style={{marginLeft: 20, fontSize: 12}}>
                                      {value.districtDescription}
                                      </Typography>
                                    */}
                                 </div>
                                  <Checkbox
                                    icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                                    checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                                    checked={value.isChecked ? value.isChecked : false}
                                       onChange={this.handleContactCheckboxChange(value.uuid)}>
                                  >
                                  </Checkbox>
                               </div>
                             </Paper>
                             </span>                             
                         )})}
                   </ul>
                 </div>
                }

                {
                    //
                    // County
                    //
                }

                {currentIssue.level === "county" &&
                 <div>
                   <div className={classes.separatorDiv}>
                     <Typography variant="subtitle1" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                       {/*
                          County
                        */}
                       {user.geo.county.name}
                     </Typography>
                   </div>
                   <ul className={classes.contactList}>
                     {countyItems.map((value, index) =>  {
                         return (
                             <Paper className={clsx({
                                 [classes.paperRoot]: true,
                                 [classes.paperRoot_disabled]: value.isDisabled,
                             })} key={index}>
                               <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                                 <div>
                                   <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16, fontWeight: "bold"}}>
                                     {value.position.description}
                                   </Typography>
                                   <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="subtitle2"style={{marginLeft: 20, fontSize: 17, fontWeight: "normal"}}>
                                     {value.person.name}
                                   </Typography>
                                   <div/>
                                   {/*
                                      <Typography variant="body2" display="inline" style={{marginLeft: 20, fontSize: 12}}>
                                      {value.districtName}
                                      </Typography>
                                    */}
                                 </div>
                                 <Checkbox
                                   icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                                   checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                                   checked={value.isChecked ? value.isChecked : false}
                                   onChange={this.handleContactCheckboxChange(value.uuid)}>
                                 >
                                 </Checkbox>
                               </div>
                             </Paper>
                         )})}
                   </ul>
                 </div>
                }

                {
                    //
                    // City
                    //
                }

                {currentIssue.level === "city" &&
                 <div>
                                   <div className={classes.separatorDiv}>
                  <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    {user.geo.address.city.name}
                  </Typography>
                </div>
                <ul className={classes.contactList}>
                  {cityItems.map((value, index) => {
                      return (
                          <Paper className={clsx({
                              [classes.paperRoot]: true,
                              [classes.paperRoot_disabled]: value.isDisabled,
                          })} key={index}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                              <div>
                                <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="body2" display="inline" style={{marginLeft: 20, fontSize: 16, fontWeight: "bold"}}>
                                  {value.position.description}
                                </Typography>
                                <Typography className={clsx({[classes.text_disabled]: value.isDisabled})} variant="subtitle2"style={{marginLeft: 20, fontSize: 17, fontWeight: "normal" }}>
                                  {value.person.name}
                                </Typography>
                                <div/>
                              </div>
                              <Checkbox
                                icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                                checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                                checked={value.isChecked ? value.isChecked : false}
                                onChange={this.handleContactCheckboxChange(value.uuid)}>
                              </Checkbox>
                            </div>
                          </Paper>
                      )})}
                 </ul>
                 </div>
                }
                

                <FlashHeader style={{marginTop: 40}} text="Track and Share Your Issue"/>

                <Typography className={classes.subheaderText} variant="h6" style={{marginLeft: 25, marginTop: 20, marginBottom: 10, marginRight: 25}}>
                  Ways you can track and know you had an impact
                </Typography>
                
                {/*
                <FlashSubHeader style={{marginBottom: 100}} text1={
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        width: 400,
                    }}>
                      <div style={{marginBottom: 5}}>
                        <Typography className={classes.subheaderText} variant="h6">
                          Ways you can track and know you had an impact
                        </Typography>
                      </div>
                      <div style={{}}>
                        <HelpIcon style={{fontSize: 30, color: grey[500], paddingTop: 0, marginLeft: 5,}}/>
                      </div>
                    </div>
                }>
                  <Typography className={classes.subheaderText} variant="h6" style={{fontSize: 18, marginLeft: 10 }}>
                    <div style={{display: "inline", fontWeight: 400}}>We'll find the issues they cover</div>
                  </Typography>
            </FlashSubHeader>
        */}
                


                <div className={classes.separatorDiv}>
                  <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    I want to...
                  </Typography>
                </div>
                
                <ul className={classes.contactList}>
                  {optionsItems.map((value, index) => (
                      <Paper className={clsx(classes.optionsPaperRoot)}  key={index}
                             style={{
//                                 marginTop: (index === 0) ? 15 : null,
//                                 borderTopLeftRadius: (index === 0) ? 6 : 0,
                                 //                                 borderTopRightRadius: (index === 0) ? 6 : 0,
                                 borderRadius: 0,
                                 borderTop: 0,
                                 borderBottom: 0,
                             }}>
                        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                          <div>
                            <Typography variant="subtitle2" style={{marginLeft: 20, fontSize: 18, fontWeight: 400, marginTop: 8, marginBottom: 8 }}>
                              {value.txt}
                            </Typography>
                          </div>
                          <Checkbox
                            icon={<UncheckedCircle style={{color: grey[700], fontSize: 35, marginRight: 8}}/>}
                            checkedIcon={<CheckedCircle style={{color: grey[700], fontSize: 35, marginRight: 8}}/>}
//                            onChange={this.handleCheckboxChange(value.uuid)}
                            onClick={this.handleCheckboxChange(value.slug)}
                            checked={value.isChecked ? value.isChecked : false}
                          />
                        </div>
                        <div style={{
                            height: (this.state.isTrackingOpen) ? (reasonsData.length * 70 + 150) + (250) + 15 : 0

                        }}>
                          { true &&
                            <div>
                              <Typography variant="subtitle2" style={{marginLeft: 20, fontSize: 18, fontWeight: 400, marginTop: 8, marginBottom: 8 }}>
                                Not real data (yet) - for feature demo only
                              </Typography>

                              <Typography variant="subtitle2" style={{marginLeft: 20, fontSize: 15, fontWeight: 400, marginTop: 8, marginBottom: 8 }}>
                                You will be updated on the progress via email:
                              </Typography>

                              <div style={{
                                  marginLeft: 20,
                                  marginRight: 20,
                                  paddingLeft: 1, // for some reason need to pad for the border to show
                                  borderStyle: "solid",
                                  borderColor: grey[400],
                                  borderWidth: 1,
                              }}>
                                <FlashIssueChart title={this.state.gl.currentIssue.txt}/>
                              </div>
                              <div style={{
                                  marginTop: 15,
                                  marginLeft: 20,
                                  marginRight: 20,
                                  paddingLeft: 1, // for some reason need to pad for the border to show
                                  borderStyle: "solid",
                                  borderColor: grey[400],
                                  borderWidth: 1,
                                  height: reasonsData.length * 70 + 150
                              }}>
                                <FlashReasonsChart
                                  title={this.state.gl.currentIssue.txt}
                                  data={reasonsData}/>
                              </div>

                            </div>
                      }
                        </div>
                      </Paper>
                  ))}
                  <Paper className={classes.optionsPaperRoot} key={100}
                         style={{borderBottomLeftRadius: 6,
                             borderBottomRightRadius: 6, }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <div>
                        <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 18, fontWeight: 400, marginTop: 8, marginBottom: 8 }}>
                          Share my position with friends, so they can echo my reasons or add their own
                        </Typography>
                      </div>
                      <ShareIcon style={{color: grey[700], fontSize: 35, margin: 10, marginRight: 20}} onClick={this.handleShareClick}/>
                    </div>
                  </Paper>
                </ul>
                
                
              </div>

              {/*
              <FlashBottomBar
                backButton={{
                    text: "BACK",
                    link: "/preview",
                    // onClick: this.handleBack
                }}
                nextButton={{
                    text: "SUBMIT",
                    link: "/submit",
                    onClick: this.handleNext,
                    onError: this.handleError,
                }}/>
               */}

              { this.state.scrollerDirection && this.state.scrollerDirection === "down" &&
                <Fab aria-label="scroll"
                     className={clsx(classes.fab, classes.fabGreen)}
                     onClick={this.scrollToBottom}>
                  <DownIcon style={{fontSize: 50}}/>
                </Fab>
              }

              { this.state.scrollerDirection && this.state.scrollerDirection === "up" &&
                <Fab aria-label="scroll"
                     className={clsx(classes.fab, classes.fabGreen)}
                     onClick={this.scrollToTop}>
                  <UpIcon style={{fontSize: 50}}/>
                </Fab>
              }
              
              <FlashBottomPad
                backButton={{
                    text: "BACK",
                    link: genUrl(this)("/preview")
                    //link: "/preview",
                    // onClick: this.handleBack
                }}
                nextButton={{
                    text: "SUBMIT",
                    //link: "/submit",
                    link: genUrl(this)("/submit"),
                    onClick: this.handleNext,
                    onError: this.handleError,
                }}
              />

              <div ref={(el) => { this.tailDivEl = el }} ></div>
              
            </React.Fragment>
	)
    }
}

Summary.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {name: "Summary"})(Summary)

